import { Input, TextArea } from '@progress/kendo-react-inputs'
import { Hint } from "@progress/kendo-react-labels";
import { Field as CustomField, IField } from '../../../types/Form/IForm'
import { Field, FieldRenderProps, } from '@progress/kendo-react-form';
import React, { FunctionComponent } from 'react'

const TextField: FunctionComponent<FieldRenderProps> = formRenderProps => {
  const { field, companyId, ...others } = formRenderProps;
  const currentValue = field?.VALUES?.length > 0 ? field.VALUES[0] : null;
  const [value, setValue] = React.useState(currentValue)// ?  currentValue : field.ConfigSettings?.Default);
  const [currentField, setCurrentField] = React.useState<IField>(field);
  const max = field.ConfigSettings.Max;
  const handleChange = (e) => {

    setValue(e.value);

    console.log('chnage', e.value, value)

  };
  const blurry = (e) => {
    //Bubble the event up to the ticket component so the data can be saved
    const changeField = { ...currentField };
    changeField.VALUES = [value];

    formRenderProps.onChange({ value: changeField });
  }
  if (field.ConfigSettings?.Display == "1")
    return (
      <>
        <TextArea
          {...others}
          onChange={handleChange}
          onBlur={blurry}
          valid={true}
          id='txtField'
          disabled={false}
          maxLength={max}
          rows={4}
          value={value || ''}

        />
        {max &&
          <Hint direction={"end"}>
            {value ? value.length : 0} / {max}
          </Hint>
        }
      </>)
  else
    return (
      <>
        <Input {...others} maxLength={max} onChange={handleChange} value={value} onBlur={blurry} />
        {max &&
          <Hint direction={"end"}>
            {value ? value.length : 0} / {max}
          </Hint>
        }
      </>
    )

}

export default TextField;